module.exports = __webpack_public_path__ + "static/media/home-back.b5c1a3d8.png";